import React, { useState, useEffect } from "react";
import PortfolioItem from "./PortfolioItem";

const Portfolio = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetch("data/project-data.json")
      .then((res) => res.json())
      .then((res) => {
        setItems(res["portfolio"]);
      });
  }, []);

  return (
    <section className="text-center space--even" id="portfolio">
      <div className="container-fluid px-5">
        <div className="row">
          <div className="col-md-12">
            <h2 className="mb-0">Selected Client Work</h2>
          </div>
        </div>
        {items.map((port, i) => (
          <PortfolioItem details={port} key={port.title} id={i} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
